import { DEFAULT_POLLING_INTERVAL, DEFAULT_MAX_POLLING_TIME } from '../constants.esm.js';

/**
 * Returns the `pollForCookieChanges` function that initializes a polling loop
 * Abstracted for testing purposes
 */
var getPollForCookieChange = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.pollingInterval, pollingInterval = _c === void 0 ? DEFAULT_POLLING_INTERVAL : _c, _d = _b.maxPollingTime, maxPollingTime = _d === void 0 ? DEFAULT_MAX_POLLING_TIME : _d;
    /**
     * Polls document.cookie for changes,
     * calling `callback` when *any* document cookie changes
     */
    return function pollForCookieChanges(callback) {
        var lastCookie = document.cookie;
        var loopCount = 0;
        var repeater = setInterval(function () {
            /**
             * If we've exceeded max polling time, stop polling
             */
            if (loopCount > maxPollingTime / pollingInterval && repeater !== undefined) {
                clearInterval(repeater);
            }
            var myCookie = document.cookie;
            /**
             * If *any* cookie changes, `callback` will be invoked
             * the callback should check for the specific cookie we're interested in before triggering further action
             */
            if (myCookie !== lastCookie) {
                try {
                    callback({ newValue: myCookie, oldValue: lastCookie }, repeater);
                }
                finally {
                    lastCookie = myCookie;
                }
            }
            loopCount++;
        }, pollingInterval);
        return repeater;
    };
};

export { getPollForCookieChange };
//# sourceMappingURL=pollForCookieChange.esm.js.map
